import { render, staticRenderFns } from "./Blade1.vue?vue&type=template&id=391c20fa&scoped=true&"
import script from "./Blade1.vue?vue&type=script&lang=ts&"
export * from "./Blade1.vue?vue&type=script&lang=ts&"
import style0 from "./Blade1.vue?vue&type=style&index=0&id=391c20fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391c20fa",
  null
  
)

export default component.exports